<ng-container *ngIf="userService.IsLoggedIn; else loginToAdd">
  <ng-container *ngIf="(fee$| async) as fee">
    <ng-container *ngIf="fee.prc_price > 0">
      <div class="p-2 d-inline-block mb-2">
        <ng-container *ngIf="!cartService.PendingUpdate">
          <ng-container *ngIf="!IsInCart">
            Price: ${{fee.prc_price}} (only ${{(fee.prc_price / bundle.courses.length) | number:'1.2-2'}} per course)
            <button class="ml-3" (click)="AddBundleToCart()">Add to cart</button>
          </ng-container>
          <ng-container *ngIf="IsInCart">
            <button (click)="RemoveBundleFromCart()">Remove from cart</button>
            <a class="btn" routerLink="../../cart">View your cart</a>
          </ng-container>
        </ng-container>
        <span *ngIf="cartService.PendingUpdate">
          <app-load-indicator description="update your cart"></app-load-indicator>
        </span>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loginToAdd>
  <div class="p-2 d-inline-block mb-2"><button (click)="ShowLoginModal();">Log in to add to cart</button></div>
</ng-template>
